import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const checkoutService = createApi({
  reducerPath: "checkoutService",
  baseQuery: fetchBaseQuery({
    baseUrl: "/api/",
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.authReducer?.userToken;

      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }

      headers.set("accept", "application/json");

      return headers;
    },
  }),
  tagTypes: ["UserAddresses"],
  endpoints: (builder) => ({
    createOrder: builder.mutation({
      query: (data) => ({
        url: "checkout",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["UserAddresses"],
    }),

    shippingMethods: builder.query({
      query: (subtotal = 0) => ({
        url: `shipping-methods?subtotal=${subtotal}`,
        method: "GET",
      }),
    }),

    applyDiscountCode: builder.mutation({
      query: (data) => ({
        url: "discount-codes/apply",
        method: "POST",
        body: data,
      }),
    }),

    validateCart: builder.mutation({
      query: (data) => ({
        url: "cart/validate",
        method: "POST",
        body: data,
      }),
    }),

    userAddresses: builder.query({
      query: () => ({
        url: "user/addresses",
        method: "GET",
      }),
      providesTags: ["UserAddresses"],
    }),

    createAddress: builder.mutation({
      query: (data) => ({
        url: "user/addresses",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["UserAddresses"],
    }),

    updateAddress: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `user/addresses/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["UserAddresses"],
    }),

    deleteAddress: builder.mutation({
      query: (id) => ({
        url: `user/addresses/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["UserAddresses"],
    }),

    setDefaultAddress: builder.mutation({
      query: (id) => ({
        url: `user/addresses/${id}/default`,
        method: "POST",
      }),
      invalidatesTags: ["UserAddresses"],
    }),
  }),
});

export const {
  useCreateOrderMutation,
  useShippingMethodsQuery,
  useApplyDiscountCodeMutation,
  useValidateCartMutation,
  useUserAddressesQuery,
  useCreateAddressMutation,
  useUpdateAddressMutation,
  useDeleteAddressMutation,
  useSetDefaultAddressMutation,
} = checkoutService;

export default checkoutService;
